import { SvgIcon } from '@mui/material';

const CollectionService = props => (
  <SvgIcon width='25' height='25' viewBox='0 0 25 25' {...props}>
    <g id='Group_144' data-name='Group 144' transform='translate(-7902 -6286)'>
      <circle
        id='Ellipse_3'
        data-name='Ellipse 3'
        cx='12.5'
        cy='12.5'
        r='12.5'
        transform='translate(7902 6286)'
        fill='#fff'
      />
      <g
        id='Group_35'
        data-name='Group 35'
        transform='translate(7907.499 6270.271)'
      >
        <path
          id='Path_9'
          data-name='Path 9'
          d='M104.354,28.888a3.462,3.462,0,0,1,2.774.221h2.843a1.414,1.414,0,0,1,1.233.73l.87-.619v-7.38h-2.952v4.787h-2.867V21.839H103.3V29.5A3.1,3.1,0,0,1,104.354,28.888Z'
          transform='translate(-100.483)'
          fill='#dc0032'
        />
        <path
          id='Path_10'
          data-name='Path 10'
          d='M241.413,21.839h1.229v3.968h-1.229Z'
          transform='translate(-234.822 0)'
          fill='#dc0032'
        />
        <path
          id='Path_11'
          data-name='Path 11'
          d='M113.984,302.375a1.019,1.019,0,0,0-1.422-.239l-1.468,1.046a1.426,1.426,0,0,1-1.406,1.26h-1.762v-.819h1.762a.618.618,0,0,0,0-1.235h-3.057a2.586,2.586,0,0,0-2.294-.265,2.28,2.28,0,0,0-1.325,1.168v3.788h6.111l4.622-3.283a1.019,1.019,0,0,0,.239-1.421Z'
          transform='translate(-100.201 -272.461)'
          fill='#dc0032'
        />
        <path
          id='Path_12'
          data-name='Path 12'
          d='M0,324.23H1.993v4.524H0Z'
          transform='translate(0 -294.135)'
          fill='#dc0032'
        />
      </g>
    </g>
  </SvgIcon>
);

export default CollectionService;
